import { Box, Typography } from '@mui/material';

import { SHRED_COLORS, SHRED_COPY, SHRED_FEED_ICONS, SHRED_FONTS } from '../constants';
import { buildFeedSentence, groupFeedByDay } from '../helpers';
import { Panel, SectionTitle } from './shared';

const Feed = ({ feed }) => {
  const groups = groupFeedByDay(feed)
    .map((group) => ({
      day: group.day,
      items: group.events.map((event) => ({ event, text: buildFeedSentence(event) })).filter((item) => item.text),
    }))
    .filter((group) => group.items.length > 0);

  return (
    <Box component="section" aria-labelledby="shred-feed-title">
      <SectionTitle kicker="What just happened" title={SHRED_COPY.FEED_TITLE} id="shred-feed-title" />
      <Panel tabIndex={0} role="region" aria-label={SHRED_COPY.FEED_TITLE} sx={{ maxHeight: 520, overflowY: 'auto', '&:focus-visible': { outline: `2px solid ${SHRED_COLORS.gold}`, outlineOffset: 2 } }}>
        {groups.length === 0 && (
          <Typography sx={{ p: 3, color: SHRED_COLORS.muted, fontFamily: SHRED_FONTS.body, textAlign: 'center' }}>{SHRED_COPY.FEED_EMPTY}</Typography>
        )}
        {groups.map((group) => (
          <Box key={group.day}>
            <Typography
              sx={{
                position: 'sticky',
                top: 0,
                px: 2,
                py: 0.75,
                zIndex: 1,
                fontFamily: SHRED_FONTS.numeric,
                fontSize: 11,
                letterSpacing: '0.16em',
                color: SHRED_COLORS.flame,
                background: SHRED_COLORS.panelRaised,
              }}
            >
              DAY {group.day}
            </Typography>
            <Box component="ul" sx={{ listStyle: 'none', m: 0, p: 0 }}>
              {group.items.map(({ event, text }, index) => (
                <Box
                  component="li"
                  key={`${group.day}-${event.type}-${event.id}-${index}`}
                  sx={{ display: 'flex', gap: 1.25, px: 2, py: 1.1, borderBottom: `1px solid ${SHRED_COLORS.line}`, fontFamily: SHRED_FONTS.body, fontSize: 14, lineHeight: 1.4 }}
                >
                  <span aria-hidden="true">{SHRED_FEED_ICONS[event.type]}</span>
                  <span>{text}</span>
                </Box>
              ))}
            </Box>
          </Box>
        ))}
      </Panel>
    </Box>
  );
};

export default Feed;
